import FormCheckbox from './FormCheckbox';

export default FormCheckbox;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/FormCheckbox/index.js